// extracted by mini-css-extract-plugin
export default {"container":"IconGrid_container__-Knef","desktop":"IconGrid_desktop__C4eQu","mobile":"IconGrid_mobile__-5Pcg","mobile-sm":"IconGrid_mobile-sm__nMHJW"};